module.exports = __webpack_public_path__ + "7804f7ff0b8d8ddeb0f3dc9b2ae2d5a2.pdf";